import type { ProductLotStockOutNoteItem } from '@/lib/api/product-lot-api'

export type VerifyScanResult =
    | { kind: 'match'; item: ProductLotStockOutNoteItem }
    | {
          kind: 'mismatch'
          scannedShort: string
          expected: ProductLotStockOutNoteItem
      }
    | { kind: 'not-in-note'; scannedShort: string }

function short(uuid: string): string {
    return uuid.length > 8 ? `${uuid.slice(0, 8)}…` : uuid
}

export function verifyScan(
    scannedLotId: string,
    items: ReadonlyArray<ProductLotStockOutNoteItem>,
    focusedItemId?: string,
): VerifyScanResult {
    const focused = focusedItemId
        ? items.find((it) => it.id === focusedItemId)
        : undefined

    if (focused) {
        if (focused.product_lot_id === scannedLotId) {
            return { kind: 'match', item: focused }
        }
        const inNote = items.some((it) => it.product_lot_id === scannedLotId)
        if (inNote) {
            return {
                kind: 'mismatch',
                scannedShort: short(scannedLotId),
                expected: focused,
            }
        }
        return { kind: 'not-in-note', scannedShort: short(scannedLotId) }
    }

    const match = items.find((it) => it.product_lot_id === scannedLotId)
    if (match) return { kind: 'match', item: match }
    return { kind: 'not-in-note', scannedShort: short(scannedLotId) }
}
